// IMPORT PACKAGE REFERENCES

import { applyMiddleware, compose, createStore } from 'redux';

import { AppReducer } from '../reducers/AppReducer';
import { createLogger } from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';

// IMPORT MIDDLEWARE

// IMPORT REDUCERS

// CONFIGURE STORE

export const createAppStore = initialState => {
    const middlewares = [thunk, promise];
    if (process.env !== 'production') {
        middlewares.push(createLogger());
    }
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

    const store = createStore(
        AppReducer,
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/AppReducer', () => {
            const nextRootReducer = require('../reducers/AppReducer');
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
};
